export const isValidNeglectedOrDelinquentCount = (value: unknown): value is string =>
    typeof value === 'string' && /^\d{1,6}$/.test(value);
